import React from 'react'

const EnregistrementVente = () => {
  return (
    <div>
      <h2>Enregistrement Vente</h2>
    </div>
  )
}

export default EnregistrementVente
